<template>
  <div
    class="
      flex gap-6
      print:hidden
    "
  >
    <NuxtLink
      class="group flex items-center"
      :aria-label="$t('aria_label.mail_url')"
      :to="mailLinkUrl"
    >
      <IconMail
        class="
          h-5 w-auto cursor-pointer fill-gray-500/75
          group-hover-focus:fill-red-500
        "
      />
    </NuxtLink>
    <button
      type="button"
      class="group"
      :aria-label="$t('aria_label.print')"
      @click="triggerPrintDialog()"
      @keydown.enter="triggerPrintDialog()"
    >
      <IconPrinter
        class="
          h-[1.8rem] w-auto cursor-pointer stroke-gray-500/75
          group-hover-focus:stroke-red-500
        "
      />
    </button>
    <button
      v-if="globals?.network_navigation.nav_group && globals?.network_navigation.nav_group.length > 0"
      type="button"
      class="group"
      :aria-label="$t('aria_label.network_navigation')"
      @click="navigation.getNetworkNavOpen ? navigation.setNetworkNavOpenState(false) : toggleNetworkNav()"
    >
      <IconNetwork
        class="
          h-[1.8rem] w-auto cursor-pointer stroke-gray-500/75
          group-hover-focus:stroke-red-500
        "
      />
    </button>
    <NetworkNavigation />
  </div>
</template>

<script lang="ts" setup>
const globals = inject(GlobalsKey)
const navigation = useNavigationStore()
const entry = inject(EntryInjectionKey)

const { t } = useI18n()

const triggerPrintDialog = () => {
  navigation.setOpenState(false)
  window.print()
}

const toggleNetworkNav = () => {
  const timeout = navigation.getOpen ? 125 : 0

  navigation.setOpenState(false)
  setTimeout(() => {
    navigation.toggleNetworkNavOpen()
  }, timeout)
}

const mailLinkUrl = computed(() => {
  if (!entry?.value?.permalink) {
    return
  }

  const mailSubject = `${t('share.checkout')}: ${entry.value.title}`

  const mailBody = `${t('share.checkout')}: ${entry.value.title} -> ${encodeURIComponent(entry?.value?.permalink)}`

  return `mailto:?subject=${mailSubject}&body=${mailBody}`
})
</script>
